import Axios from "api/axios"
import { history } from "app-history"
import qs from "query-string"

export const gateway = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/auth/gateway'
    })
    const statusOK = result.status === 200 || result.status === 304
    if (statusOK && result.data.message) return true
    else return false
  } catch (error) {
    return false
  }
}

export const login = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/login',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const resetRequest = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/resetrequest',
      data: {
        ...form,
      }
    })
    history.push(`/auth-reset?email=${form.email}`)
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}


export const resetConfirm = async (form) => {
  const params = qs.parse(history.location.search)

  if (!params.email) history.push('/auth-reset')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/resetconfirm',
      data: {
        ...form,
      },
      params
    })
    history.push(`/auth-reset?email=${params.email}&resetPasswordToken=${result.data.resetPasswordToken}`)
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const resetSubmit = async (form) => {
  const params = qs.parse(history.location.search)

  if (!params.email || !params.resetPasswordToken) history.push('/auth-reset')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/resetsubmit',
      data: form,
      params
    })

    if (params.redirect) {
      history.push(`${params.redirect}`)
    }

    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const loginReset = async (form) => {
  const params = qs.parse(history.location.search);

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/loginreset',
      data: {
        ...form,
        ...params,
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const register = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/register',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const registerApply = async (form, jobParams) => {
  let register, apply;

  try {
    register = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/register',
      data: {
        ...form,
        // customQuestions,
        companyReferral: jobParams
      }
    })
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }

  try {
    apply = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/apply',
      data: jobParams
    })
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }

  return {
    register: register.data,
    apply: apply.data
  }
}

export const getProfile = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/profile'
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const logout = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/logout'
    })
    const statusOK = result.status === 200 || result.status === 304
    if (statusOK && result.data.message) return true
    else return false
  } catch (error) {
    return false
  }
}

// export const resetRequest = async (form) => {
//   try {
//     const result = await Axios({
//       withCredentials: true,
//       method: 'POST',
//       url: '/auth/resetrequest',
//       data: form
//     })

//     history.push(`/auth/reset/confirm?email=${form.email}`)
//     return result.data
//   } catch (error) {
//     if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
//     else return error.response.data
//   }
// }
